import React from "react";
import { TextLink } from "@trussle/external-components";
import "./styles.scss";
import cn from "classnames";
import { renderRichText } from "gatsby-source-contentful/rich-text";
import { navigate } from "gatsby";
import { IContentfulRichTextResponse } from "../../types/IContentfulRichText";

export type ArticleCardProps = {
    title: string;
    subTitle?: string;
    content?: IContentfulRichTextResponse;
    linkText: string;
    linkURL: string;
    betterV2?: boolean;
};

const ArticleContent: React.FC<ArticleCardProps> = ({
  betterV2,
  title,
  subTitle,
  content,
  linkURL,
  linkText,
}) => (
  <article className={cn("article-card", { betterV2 })}>
    <h2 className={cn("article-card-title", { betterV2 })}>{title}</h2>
    {!betterV2 && <p className="article-card-subTitle">{subTitle}</p>}
    {(betterV2 && content) ? <p className="article-card-content">{renderRichText(content)}</p> : null}
    {!betterV2 ? (
      <TextLink
        className="article-card-link"
        href={linkURL}
        target="_blank"
      >
        {linkText}
      </TextLink>
    ) : null}
  </article>
);
const ArticleCard: React.FC<ArticleCardProps> = ({
  title,
  subTitle,
  linkText,
  linkURL,
  content,
  betterV2,
}) => {
  const onCardClick = (url: string) => {
    navigate(url);
  };
  return (
    <>
      {betterV2
        ? (
          <button
            name="article-card-button"
            className="article-card-button"
            type="button"
            onClick={() => onCardClick(linkURL)}
            aria-label="Card button"
          >
            <ArticleContent
              title={title}
              subTitle={subTitle}
              linkText={linkText}
              linkURL={linkURL}
              content={content}
              betterV2={betterV2}
            />
          </button>
        )
        : (
          <ArticleContent
            title={title}
            subTitle={subTitle}
            linkText={linkText}
            linkURL={linkURL}
            betterV2={betterV2}
          />
        )}
    </>
  );
};

export default ArticleCard;
